export default __webpack_public_path__ + "static/media/2261.57611f3f.png";